/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptTaxEditor extends Common.GridEditorBase<JobWorkReceiptTaxRow> {
        protected getColumnsKey() { return "Production.JobWorkReceiptTax"; }
        protected getLocalTextPrefix() { return JobWorkReceiptTaxRow.localTextPrefix; }
        protected form: JobWorkReceiptTaxForm;

       

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        public getData(TaxDetails) {
            var tmp =[];
            for (let orderDetail of TaxDetails) {
                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = orderDetail;
                tmp.push(orderDetail);
            }
            return tmp;

        }



        public DeleteTax() {
            var data = [];
            this.view.setItems(data, false);
            this.view.refresh();
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }


        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();
            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

    }
}